import { useContext, useEffect, useState } from "react";
import Context from "../../../common/components/utils/context";
import {
  IUpdateAccountRequest,
} from "../../../common/models/accounts";
import { Loading } from "../../../common/components/loading/loading";
import { AccountsV1Service } from "../../../common/services/api/api";
import { Themes } from "../../../common/enums/themes";

export const AccountSettings = () => {
  const context = useContext(Context);
  const [loading, setLoading] = useState<boolean>(true);
  const [account, setAccount] = useState<IUpdateAccountRequest>();

  const fetchAccount = async () => {
    if (account != null && account != undefined) {
      try {
        setLoading(true);
        const accountsService = new AccountsV1Service();
        var response = await accountsService.get();

        setAccount(response.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching account settings:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    setAccount(context.account as IUpdateAccountRequest);
    setLoading(false);
  }, [context]);

  const updateAccount = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setLoading(true);

    try {
      const accountsService = new AccountsV1Service();
      var response = await accountsService.updateAccount({ ...account });

      if (response.data) {
        await fetchAccount();
        setAccount(response.data);
        context.setAlert({
          message: "Account settings updated.",
          theme: Themes.Success,
        });
      } else {
        context.setAlert({
          message: "An error occured while updating your account settings.",
          theme: Themes.Danger,
        });
      }
    } catch (error) {
      console.error("Error updating account settings:", error);
    } finally {
      setLoading(false);
    }
  };

  return loading ? (
    <Loading />
  ) : (
    <>
      <form
        onSubmit={updateAccount}
        className="overflow-hidden px-4 pb-4 flex flex-col space-y-4"
      >
        <input
          type="hidden"
          name="membership"
          defaultValue={account?.membership}
        />
        <input
          type="hidden"
          name="company"
          defaultValue={account?.company?.name}
        />
        <fieldset className="border rounded-lg p-4">
          <h2 className="mb-4 font-sans font-medium">Settings</h2>
          <div className="columns-2">
            <label htmlFor="username" className="text-gray-500 text-sm">
              User name
              <input
                type="text"
                className="block w-full bg-gray-50 outline-none border-b py-2 px-4 mb-4"
                id="username"
                name="username"
                defaultValue={account?.username}
                onChange={(e) => {
                  setAccount({ ...account, username: e.target.value });
                }}
                required
              />
            </label>
            <label htmlFor="email" className="text-gray-500 text-sm">
              Email
              <input
                type="email"
                className="block w-full bg-gray-50 outline-none border-b py-2 px-4 mb-4"
                id="email"
                name="email"
                defaultValue={account?.email}
                onChange={(e) => {
                  setAccount({ ...account, email: e.target.value });
                }}
                required
              />
            </label>
          </div>
        </fieldset>
        <div className="grid grid-flow-col justify-end space-x-4">
          <button
            type="submit"
            disabled
            className="rounded-lg text-gray-800 text-sm tracking-wider font-medium outline-none bg-text-link px-10 py-2"
          >
            Update Settings
          </button>
        </div>
      </form>
      <form className="overflow-hidden p-4 flex flex-col space-y-4">
        <fieldset className="border rounded-lg p-4">
          <h2 className="mb-4 font-sans font-medium">Change Password</h2>
          <div className="columns-3">
            <label htmlFor="old" className="text-gray-500 text-sm">
              Current Password
              <input
                type="text"
                className="block w-full bg-gray-50 outline-none border-b py-2 px-4 mb-4"
                id="old"
                name="old"
                autoComplete="current-password"
                required
              />
            </label>
            <label htmlFor="new" className="text-gray-500 text-sm">
              New password
              <input
                type="password"
                className="block w-full bg-gray-50 outline-none border-b py-2 px-4 mb-4"
                id="new"
                name="new-password"
                autoComplete="new-password"
                required
              />
            </label>
            <label htmlFor="repeat" className="text-gray-500 text-sm">
              Re-type password
              <input
                type="password"
                className="block w-full bg-gray-50 outline-none border-b py-2 px-4 mb-4"
                id="repeat"
                name="repeat"
                autoComplete="new-password"
                required
              />
            </label>
          </div>
        </fieldset>
        <div className="grid grid-flow-col justify-end space-x-4">
          <button
            type="submit"
            className="rounded-lg text-gray-800 text-sm tracking-wider font-medium outline-none bg-text-link px-10 py-2"
          >
            Update Password
          </button>
        </div>
      </form>
      <div className="p-4">
        <div className="block border rounded-lg p-4">
          <h2 className="mb-4 font-sans font-medium text-base">
            Account Actions
          </h2>
          <div className="grid grid-flow-col justify-stretch space-x-4">
            <button
              type="button"
              className="rounded-lg text-gray-400 border border-gray-300 text-sm tracking-wider font-medium outline-none hover:bg-gray-100 px-10 py-2"
            >
              Sign out
            </button>
            <button
              type="button"
              className="rounded-lg text-gray-400 border border-gray-300 text-sm tracking-wider font-medium outline-none hover:bg-gray-100 px-10 py-2"
            >
              Deactivate Account
            </button>
            <button
              type="button"
              className="rounded-lg text-gray-400 border border-gray-300 text-sm tracking-wider font-medium outline-none hover:bg-gray-100 px-10 py-2"
            >
              Delete Account
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
